import React from 'react'
import Homepage from '../components/Homepage'

class Home extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            connMobile : this.props.connMobile
        }
    }

    componentDidUpdate(){
        if(this.state.connMobile!==this.props.connMobile){this.setState({connMobile:this.props.connMobile})}
        
    }

    render() {
        return (
            <div>
                <Homepage connMobile={this.state.connMobile} />
            </div>
        )
    }
}

export default Home;